import React, { useRef } from 'react';
import { motion, useInView } from 'framer-motion';
import { DownloadIcon, ShieldCheckIcon, LockIcon, FileTextIcon } from 'lucide-react';
import { trackAddToCart } from '../utils/pixel';
export function CTASection() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  return <section id="cta" ref={ref} className="w-full py-24 md:py-32 bg-[#FAF7F2] relative overflow-hidden" data-id="element-14">
      <div className="max-w-3xl mx-auto px-6 relative z-10" data-id="element-15">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {
        opacity: 0,
        y: 30
      }} transition={{
        duration: 0.8,
        ease: 'easeOut'
      }} className="text-center" data-id="element-16">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-[#1B4B5A] mb-16 font-serif" data-id="element-17">
            Tu inversión en la relación
          </h2>

          <div className="bg-white rounded-3xl p-10 md:p-14 shadow-[0_20px_50px_-20px_rgba(27,75,90,0.15)] border-t-4 border-[#1B4B5A] relative" data-id="element-18">
            <div className="mb-10" data-id="element-19">
              <div className="flex flex-col items-center justify-center gap-2 mb-4" data-id="element-20">
                <span className="text-2xl text-[#7A7A6E] line-through font-medium opacity-70 font-sans" data-id="element-21">
                  $15.900
                </span>
                <div className="text-6xl md:text-7xl font-bold text-[#1B4B5A] font-serif tracking-tight" data-id="element-22">
                  $5.088{' '}
                  <span className="text-2xl font-normal text-[#1B4B5A]/70 font-sans tracking-normal" data-id="element-23">
                    ARS
                  </span>
                </div>
              </div>
              <p className="text-[#7A7A6E] font-medium text-lg font-sans" data-id="element-24">
                Acceso inmediato de por vida en PDF
              </p>
            </div>

            <motion.a href="https://clavedepaz.com/cart/44108367659107:1" target="_blank" rel="noopener noreferrer" onClick={trackAddToCart} whileHover={{
            scale: 1.02
          }} whileTap={{
            scale: 0.98
          }} animate={{
            boxShadow: ['0 0 0 0 rgba(194, 113, 79, 0)', '0 0 0 15px rgba(194, 113, 79, 0.1)', '0 0 0 0 rgba(194, 113, 79, 0)']
          }} transition={{
            duration: 2.5,
            repeat: Infinity,
            repeatType: 'reverse'
          }} className="w-full bg-[#4fc251] text-white px-8 py-6 rounded-xl text-xl font-semibold shadow-[0_10px_25px_-5px_rgba(194,113,79,0.4)] hover:bg-[#A85D3F] transition-colors flex items-center justify-center gap-3 mb-10 font-sans tracking-wide" data-id="element-25">
              <DownloadIcon className="w-6 h-6" data-id="element-26" />
              DESCARGAR PRODUCTO
            </motion.a>

            {/* Guarantee Box */}
            <div className="bg-[#FAF7F2] border border-[#E8E0D4] rounded-2xl p-6 mb-8 flex flex-col items-center text-center gap-3" data-id="element-27">
              <ShieldCheckIcon className="w-8 h-8 text-[#1B4B5A]" strokeWidth={1.5} data-id="element-28" />
              <p className="text-[#2C2C2C] font-medium leading-relaxed font-sans" data-id="element-29">
                Si no te sirve, te devolvemos tu dinero.
                <br data-id="element-30" />
                <span className="text-[#7A7A6E]" data-id="element-31">7 días de garantía.</span>
              </p>
            </div>

            <div className="flex flex-wrap items-center justify-center gap-6 md:gap-8 text-sm text-[#7A7A6E] pt-8 border-t border-[#E8E0D4] font-sans" data-id="element-32">
              <div className="flex items-center gap-2" data-id="element-33">
                <LockIcon className="w-4 h-4 text-[#1B4B5A]" data-id="element-34" />
                Pago seguro
              </div>
              <div className="flex items-center gap-2" data-id="element-35">
                <DownloadIcon className="w-4 h-4 text-[#1B4B5A]" data-id="element-36" />
                Descarga inmediata
              </div>
              <div className="flex items-center gap-2" data-id="element-37">
                <FileTextIcon className="w-4 h-4 text-[#1B4B5A]" data-id="element-38" />
                PDF
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}